<template>
  <div>
    <multiselect-ajax
        :key="`${_uid}-jala-farms`"
        :name="name || 'farm_id'"
        :placeholder="$t('Select {something}', { something: $t('jala_farms.singular') })"
        :value="value"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel"
        :required="required"
        :disabled="disabled"
        :url="`/jala/farms`"
        :params="{ ...params }"
    >
      <template v-slot:beforeList>
        <b-button variant="link" v-b-modal="`${_uid}-jala-farm-create-modal`">+
          {{ $t('Add new {something}', {something: $t('jala_farms.singular')}) }}
        </b-button>
        <jala-farm-create-modal
            :key="`${_uid}-jala-farm-create-modal-${value}`"
            :id="`${_uid}-jala-farm-create-modal`"
            size="lg"
            @created="onInput($event.id)"
        ></jala-farm-create-modal>
      </template>
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }"></slot>
      </template>
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "./vue-multiselect-ajax";
import JalaFarmCreateModal from '../modals/jala-farm-create';

export default {
  name: "jala-farm-select-ajax",
  components: {
    MultiselectAjax,
    JalaFarmCreateModal,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default: undefined
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
